import type { CityConfig } from "../city-template/types";

export const somersworthConfig: CityConfig = {
  city: "Somersworth",
  state: "New Hampshire",
  stateAbbr: "NH",
  slug: "somersworth",
  route: "/cities/somersworth",
  title: "Emergency Passport Somersworth, NH | Fast Passport Renewal & Expedited Help",
  metaDescription: "Emergency passport and expedited passport services in Somersworth, NH — as fast as 24 hours. Fast passport renewal, same-day help, and child passport expediting for Strafford County and southern New Hampshire travelers. A+ BBB rated, registered State Dept. courier.",
  h1: "Emergency & Expedited Passport Services in Somersworth, NH",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Somersworth and Strafford County travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Somersworth%20New%20Hampshire%20scenic%20downtown%20with%20historic%20mill%20buildings%20along%20the%20Salmon%20Falls%20River%2C%20charming%20New%20England%20small%20town%20streetscape%2C%20warm%20summer%20afternoon%20light%20with%20green%20trees%2C%20industrial%20heritage%20architecture%20converted%20to%20modern%20use%2C%20clean%20and%20inviting%20scene%2C%20no%20visible%20text%20or%20people%2C%20professional%20architectural%20photography%2C%20warm%20earth%20tones%20and%20soft%20blue%20sky%2C%20photorealistic%20cityscape%2C%20New%20England%20mill%20town%20charm&width=1800&height=700&seq=somersworth-nh-hero-001&orientation=landscape",
  heroImageAlt: "Somersworth New Hampshire historic mill buildings along the Salmon Falls River",
  geoPosition: "43.2617;-70.8653",
  geoPlacename: "Somersworth, New Hampshire",
  regionalAgency: {
    name: "Boston Passport Agency",
    address: "5 Customs House St, Boston, MA 02103",
    distance: "Located in downtown Boston — approximately 70–90 minutes from Somersworth via I-95",
  },
  nearbyCitiesZips: [
    { name: "Somersworth", zips: "03878" },
    { name: "Dover", zips: "03820–03822" },
    { name: "Rochester", zips: "03839, 03867–03868" },
    { name: "Rollinsford", zips: "03869" },
    { name: "Berwick", zips: "03901" },
    { name: "South Berwick", zips: "03908" },
    { name: "North Berwick", zips: "03906" },
    { name: "Eliot", zips: "03903" },
    { name: "Barrington", zips: "03825" },
    { name: "Farmington", zips: "03835" },
    { name: "Milton", zips: "03851" },
    { name: "New Durham", zips: "03855" },
    { name: "Madbury", zips: "03823" },
    { name: "Lee", zips: "03861" },
    { name: "Strafford", zips: "03884" },
    { name: "Durham", zips: "03824" },
    { name: "Newmarket", zips: "03857" },
    { name: "Exeter", zips: "03833" },
    { name: "Portsmouth", zips: "03801–03804" },
    { name: "Hampton", zips: "03842–03843" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Strafford County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels to our processing center" },
  ],
  internalLinks: [
    { name: "Manchester", route: "/cities/manchester" },
    { name: "Nashua", route: "/cities/nashua" },
    { name: "Portsmouth", route: "/cities/portsmouth" },
    { name: "Dover", route: "/cities/dover" },
    { name: "Rochester", route: "/cities/rochester" },
    { name: "Exeter", route: "/cities/exeter" },
    { name: "Hampton", route: "/cities/hampton" },
    { name: "Durham", route: "/cities/durham" },
    { name: "Newmarket", route: "/cities/newmarket" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Somersworth remotely via secure courier. We do not have a walk-in office in Somersworth — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Strafford County travelers.",
  fpcOfficeDistance: "Serving all of Strafford County and southern New Hampshire",
  serviceAreaIntro: "From Somersworth's historic mill district to the Highland Avenue neighborhood, from the Salmon Falls River waterfront to the Rollinsford border — Fast Passport Center serves the entire Somersworth community. We regularly help travelers from Dover, Rochester, Rollinsford, and Berwick ME get their passports fast.",
  nearbyCitiesIntro: "We serve all Somersworth neighborhoods and nearby Strafford County cities including Dover, Rochester, Rollinsford, Barrington, Farmington, Milton, New Durham, Madbury, Lee, Strafford, Durham, Newmarket, Exeter, Portsmouth, and Hampton. We also serve southern Maine towns including Berwick, South Berwick, and Eliot. If you are in the greater Somersworth area, we have you covered.",
  howItWorksIntro: "Most Somersworth travelers complete everything online and ship documents overnight. No need to drive to Boston — our courier handles the in-person delivery for you.",
  mistakesIntro: "With easy access to Portsmouth International (PSM) and Manchester-Boston Regional (MHT), Strafford County travelers can't afford passport delays. Here are the most common mistakes we see.",
  testimonialsIntro: "Somersworth and Strafford County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Somersworth? Here are the most common ones we hear from Strafford County travelers.",
  statePageRoute: "/states/new-hampshire",
  statePageName: "New Hampshire",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–3",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Somersworth international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Amanda J.",
      location: "Somersworth, NH",
      rating: 5,
      text: "My flight to Paris was in 4 days and my passport was expired. Fast Passport Center got it renewed in 36 hours. I was on my flight with time to spare.",
      service: "Passport Renewal",
    },
    {
      name: "Michael T.",
      location: "Rollinsford, NH",
      rating: 5,
      text: "Needed a passport for my first business trip to Canada. They helped me through every step and I had it in 5 days. Great service for first-time applicants.",
      service: "New Passport",
    },
    {
      name: "Karen S.",
      location: "Dover, NH",
      rating: 5,
      text: "Lost my passport the day before my cruise. I thought my vacation was ruined. They got me a replacement in 48 hours. I will never forget that.",
      service: "Lost Passport",
    },
    {
      name: "James R.",
      location: "Berwick, ME",
      rating: 5,
      text: "As someone who crosses the border frequently for work, I need my passport ready at all times. Fast Passport Center has been my reliable partner for years.",
      service: "Expedited Renewal",
    },
  ],
  facilities: [
    {
      id: "somersworth-nh-1",
      name: "Somersworth Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2 Government Way",
      city: "Somersworth",
      state: "NH",
      zip: "03878",
      phone: "(603) 692-4444",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.2 miles from downtown Somersworth",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary acceptance facility for Somersworth. Appointments required. Call ahead to confirm passport acceptance times.",
      icon: "ri-mail-line",
    },
    {
      id: "somersworth-nh-2",
      name: "Dover Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "133 Chestnut St",
      city: "Dover",
      state: "NH",
      zip: "03820",
      phone: "(603) 742-1676",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "1.2 miles from downtown Dover",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Strafford County residents. Extended passport hours. Book appointments well in advance.",
      icon: "ri-mail-line",
    },
    {
      id: "somersworth-nh-3",
      name: "Rochester Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "22 Main St",
      city: "Rochester",
      state: "NH",
      zip: "03867",
      phone: "(603) 332-7151",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.5 miles from downtown Rochester",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Popular for northern Strafford County residents. Appointment strongly recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "somersworth-nh-4",
      name: "Berwick Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "31 Portland St",
      city: "Berwick",
      state: "ME",
      zip: "03901",
      phone: "(207) 698-1161",
      hours: "Mon–Fri: 9:00 AM – 3:00 PM",
      distance: "0.3 miles from downtown Berwick",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Maine residents near the NH border. Photo services available. Book ahead.",
      icon: "ri-mail-line",
    },
    {
      id: "somersworth-nh-5",
      name: "Rollinsford Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "605 Main St",
      city: "Rollinsford",
      state: "NH",
      zip: "03869",
      phone: "(603) 742-2520",
      hours: "Mon–Fri: 9:00 AM – 3:00 PM",
      distance: "0.4 miles from downtown Rollinsford",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves eastern Strafford County near the Maine border. Limited passport hours — call to confirm.",
      icon: "ri-mail-line",
    },
    {
      id: "somersworth-nh-6",
      name: "Somersworth City Clerk",
      type: "City Clerk Passport Acceptance",
      address: "1 Government Way",
      city: "Somersworth",
      state: "NH",
      zip: "03878",
      phone: "(603) 692-9511",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "0.1 miles from City Hall",
      website: "https://www.somersworthnh.gov/",
      websiteLabel: "Somersworth City Clerk",
      notes: "Major municipal facility with extended hours. Accepts walk-ins but appointments recommended for faster service.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — downtown Boston", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Somersworth photo shops often use generic sizes. Passport photos must be exactly 2x2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Strafford County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Somersworth applicants show up with incorrect checks and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Boston regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Somersworth families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Somersworth travelers often assume standard processing will be fine. It takes 6–13 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Somersworth." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Somersworth address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Somersworth before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Somersworth for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround for most Strafford County travelers." },
    { q: "How fast can I renew my passport in Somersworth?", a: "Fast Passport Center offers fast passport renewal in Somersworth in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value." },
    { q: "What if my passport expires before my cruise?", a: "If your passport expires before your cruise, contact Fast Passport Center immediately. We can expedite your passport renewal in Somersworth in 24–48 hours so you don't miss your departure." },
    { q: "Can I get a same-day passport appointment near Somersworth?", a: "Same-day passport appointments are only available at the Boston Regional Passport Agency for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Somersworth residents." },
    { q: "Can I expedite a child passport in Somersworth?", a: "Yes. Fast Passport Center expedites child passports in Somersworth for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Somersworth with DS-64 form guidance. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "How fast can I get a passport in Somersworth?", a: "With Fast Passport Center's emergency courier service, Somersworth travelers can receive their passport in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays." },
    { q: "Do I need to visit the Boston Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
    { q: "Where are the closest passport acceptance facilities in Somersworth?", a: "Popular options include the Somersworth Post Office (03878), Dover Post Office (03820), Rochester Post Office (03867), Berwick Post Office (03901), Rollinsford Post Office (03869), and Somersworth City Clerk (03878). All require appointments. We help you find the most convenient location and schedule your visit." },
    { q: "Can I get a same-day passport in Somersworth?", a: "Same-day passports are only available at the Boston Regional Passport Agency for documented life-or-death emergencies with proof of travel within 72 hours. For all other urgent travel, Fast Passport Center's 24–48 hour emergency processing is the fastest reliable option." },
    { q: "What if I live in a nearby town like Dover or Rochester?", a: "We serve all of Strafford County including Dover, Rochester, Rollinsford, Barrington, Farmington, Milton, New Durham, Madbury, Lee, Strafford, Durham, Newmarket, Exeter, Portsmouth, and Hampton. We also serve southern Maine towns. Our overnight shipping labels work from any UPS location, so your location doesn't affect processing speed." },
    { q: "How much does expedited passport service cost in Somersworth?", a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24–48 hour processing, 3–5 day expedited, or standard options. Contact us for a personalized quote based on your timeline." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Somersworth", address: "11 Government Way, Somersworth, NH 03878", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Dover", address: "10 Central Ave, Dover, NH 03820", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Rite Aid — Rochester", address: "20 S Main St, Rochester, NH 03867", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walmart — Dover", address: "46 Dover Point Rd, Dover, NH 03820", hours: "Mon–Sun: 6AM–11PM" },
    { name: "UPS Store — Dover", address: "10 Front St, Dover, NH 03820", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "Shaw's — Dover", address: "8 Mast Rd, Dover, NH 03820", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Hannaford — Somersworth", address: "51 High St, Somersworth, NH 03878", hours: "Mon–Sun: 7AM–10PM" },
    { name: "Dollar General — Rochester", address: "15 Farmington Rd, Rochester, NH 03867", hours: "Mon–Sun: 8AM–10PM" },
  ],
  dmvLocations: [
    { name: "DMV — Dover", address: "10 Central Ave, Dover, NH 03820", hours: "Mon–Fri: 8AM–5PM", note: "Full-service center for Strafford County residents. Appointment recommended.", featured: true },
    { name: "DMV — Rochester", address: "20 S Main St, Rochester, NH 03867", hours: "Mon–Fri: 8AM–5PM", note: "Passport-ready photo services available. Online appointment booking.", featured: false },
    { name: "DMV — Somersworth", address: "11 Government Way, Somersworth, NH 03878", hours: "Mon–Fri: 8AM–5PM", note: "REAL ID processing. Walk-ins limited — book online first.", featured: false },
    { name: "DMV — Portsmouth", address: "3010 Lafayette Rd, Portsmouth, NH 03801", hours: "Mon–Fri: 8AM–5PM", note: "Full-service DMV for Seacoast residents.", featured: true },
  ],
  airports: [
    { code: "MHT", name: "Manchester-Boston Regional Airport", distance: "45 miles from Somersworth", address: "1 Airport Rd, Manchester, NH 03103", note: "Closest major commercial airport for Somersworth travelers. International flights to Canada and Europe.", flightUrl: "https://www.flymanchester.com/", flightLabel: "MHT Flight Info", featured: true },
    { code: "BOS", name: "Boston Logan International Airport", distance: "70 miles from Somersworth", address: "1 Harborside Dr, Boston, MA 02128", note: "Major international hub for long-haul flights to Europe, Asia, and South America. Accessible via I-95.", flightUrl: "https://www.massport.com/logan-airport", flightLabel: "Logan Airport", featured: false },
    { code: "PSM", name: "Portsmouth International Airport", distance: "12 miles from Somersworth", address: "77 Airport Rd, Portsmouth, NH 03801", note: "Regional airport with commercial flights to Florida and other domestic destinations.", flightUrl: "https://www.flyportsmouthnh.com/", flightLabel: "Portsmouth Airport", featured: false },
  ],
};